module.exports = __webpack_public_path__ + "static/media/forklift.19d3aa77.svg";